import React, { useState } from 'react';
import "./style.scss";
import * as yup from "yup";
import { useFormik } from "formik";
import { Form, Row, Col, Button, InputGroup, Spinner } from "react-bootstrap";
import { AiOutlineEyeInvisible, AiOutlineEye } from "react-icons/ai"
import { apiAdminConfig } from '../../utils/api';
import useToast from '../../provider/Toast/useToast';
import { useNavigate } from 'react-router-dom';
import { setUserCookie } from '../../utils/cookie';

const Login = () => {
  const toast = useToast();
  const navigate = useNavigate();
  const [type, setType] = useState("password");
  const [eyeIcon, setEyeIcon] = useState(<AiOutlineEyeInvisible />);

  const validationSchema = yup.object().shape({
    email: yup.string().required("Email is required"),
    password: yup.string().required("Password is required"),
  });

  const { handleSubmit, handleChange, values, errors, touched } = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema,
    onSubmit: async () => {
      await apiAdminConfig.post(`admin/login`, values).then((response) => {
        if (response?.data?.status) {
          console.log("response?.data?.data", response?.data?.data)
          toast({
            message: response?.data?.message,
            bg: 'success'
          });
          const userData = {
            userData: { customerDetails: response?.data?.data },
            token: response?.data?.data?.auth_token
          };
          setUserCookie(userData);
          navigate('/');
        } else {
          toast({
            message: response?.data?.message,
            bg: 'danger'
          });
        }
      }).catch((error) => {
        const { response } = error;
        console.log("eventError", error)
        toast({
          message: response?.data?.message,
          bg: "danger",
        });
      })
    },
  });

  const passwordView = () => {
    if (type === "password") {
      setType("text");
      setEyeIcon(<AiOutlineEye />);
    } else {
      setType("password");
      setEyeIcon(<AiOutlineEyeInvisible />);
    }
  }


  return (
    <>
      <div className='login_page'>
        <div className='login_page_form'>
          <img alt="logo" src="/asset/logo.png" />
          <h2>Log in</h2>
          <Form noValidate onSubmit={handleSubmit}>
            <Row className="mb-3">
              <Form.Group >
                <Form.Label>
                  Username or email<span className="text-danger">*</span>
                </Form.Label>

                <Form.Control
                  type="email"
                  placeholder=""
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  isInvalid={!!errors.email && touched.email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>

            <Row className="mb-3">
              <Form.Group as={Col}>
                <Form.Label>
                  Password<span className="text-danger">*</span>
                </Form.Label>
                <InputGroup>
                  <Form.Control
                    type={type}
                    placeholder=""
                    name="password"
                    value={values.password}
                    onChange={handleChange}
                    isInvalid={!!errors.password && touched.password}
                  />
                  <InputGroup.Text
                    onClick={passwordView}
                    className="icon-btn"
                  >
                    {eyeIcon}
                  </InputGroup.Text>
                </InputGroup>
                <Form.Control.Feedback type="invalid">
                  {errors.password}
                </Form.Control.Feedback>
              </Form.Group>
            </Row>

            <div className="d-grid mt-2">
              <Button
                type="submit"
                className='form_btn'
              >
                Login
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
}

export default Login;
